import {
  getDefaultWeekRange,
  getWeekRangeForAnchor,
} from '@/features/layouts/collection/group/week.dateRange';
import type { TemplateMeta } from '../../types';
import { WeekIcon } from './Icon';

export const weekMeta: TemplateMeta = {
  name: 'Week',
  orientation: 'landscape',
  Icon: WeekIcon,
  theme: 'block',
  eventListDisplayCustomLabel: 'Week',
  eventListDisplayFullLabel: null,
  eventListRangePicker: 'week',
  // A single configured week is this layout's natural period, same as the 5+2
  // week grid's. Declaring the accessors is what makes the view range-bounded:
  // it consumes `?range=`, gets the week picker, and — for the interactive kind,
  // which renders one grouped page rather than paginating — is what keeps it to
  // one week instead of every week in the planner's window.
  getDefaultRange: getDefaultWeekRange,
  getRangeForAnchor: getWeekRangeForAnchor,
  featureFlag: 'weekPrintableEnabled',
};
